import { useMutation } from '@tanstack/react-query';

import { authApi, type ForgotPasswordRequest } from '@/api/routes/public/auth.api';

export const useForgotPassword = () => {
  return useMutation({
    mutationFn: (data: ForgotPasswordRequest) => authApi.forgotPassword(data),
  });
};
